import { Component, EventEmitter, input, Output } from '@angular/core';

@Component({
  selector: 'colored-icon',
  standalone: true,
  imports: [],
  templateUrl: './colored-icon.component.html',
  styleUrl: './colored-icon.component.css',
})
export class ColoredIconComponent {
  iconClass = input<string>('fas fa-check');
  bgColorClass = input<string>('bg-green-50');
  textColorClass = input<string>('text-green-600');

  @Output() onClicked = new EventEmitter<void>();

  constructor() {}

  handleClick() {
    this.onClicked.emit();
  }
}
